import { requests } from '../../../services/external/APIs/apiAgent';
import { BonusAssignmentModel } from '../models/bonusAssignmentModel';
import { RequestBonusAssignmentRequest } from '../models/requestBonusAssignmentRequest';


const BASE_URL = '/dublin/api/v2/preliquidation-day-summaries-bonus-rules';

export const getAllBonusAssignments = async (params: RequestBonusAssignmentRequest): Promise<BonusAssignmentModel[]> => {
    return requests.post(`${BASE_URL}/search`, params);
};

export const deleteBonusAssignments = async (ids: number[]): Promise<void> => {
    return requests.deleteWithBody(BASE_URL, { ids });
};